import {ActivatedRoute, Router} from "@angular/router";
import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {
  ClientContact,
  ClientITProfile,
  NetworkDescriptionAndDiagram,
  SystemInterconnection,
  SystemRolePrivilege,
  User
} from "../../_models";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectService,
  TenantService
} from "../../_services";
import {SapProfileService} from "../../_services/sapProfile.service";
import {Access, ClientContactRole, CompanyType, DataDirection, LoginHelper, Role} from "../../helpers";
import {NameAndIdentifier} from "../../_models/nameAndIdentifier";
import {SystemLocation} from "../../_models/systemLocation";
import {Device} from "../../_models/device";
import {RoleSensitivityLevel} from "../../_models/roleSensitivityLevel";
import {OtherDesignatedContact} from "../../_models/otherDesignatedContact";
import {Constants} from "../../helpers/constants";
import {saveAs as importedSaveAs} from "file-saver";

@Component({
    standalone: false,
  selector: "sap-profile",
  templateUrl: 'sap.profile.component.html',
  styleUrls: ['./sap.profile.component.scss'],
})

export class SapProfileComponent implements OnInit {
pageTitle;
  loading = false;
  currentUser: User;
  sapProfileId: number;
  formGroup: FormGroup;
  lowMediumHigh = {0: 'Low (L)', 1: 'Moderate (M)', 2: 'High (H)'};
  profiles: any[] = [];
  profile: any;
  window = window;
  token: string;
  api: any;
  scopeCols: any[] = [
    {field: 'packageId', header: 'FedRAMP Package ID', width: '20%'},
    {field: 'cspName', header: 'CSP Name', width: '50%'},
    {field: 'csoName', header: 'CSO Name', width: '30%'},
  ];
  scopeFormGroup: FormGroup;
  scopeDialogVisible = false;
  editedScope: any;
  assessmentScopes: any[];
  leveragedScopes: any[];
  projects: any[];
  projectControlItems: any[];
  itProfiles: any[];
  projectItProfiles: any[];

  rowGroupMetadata = {};
  securityControlSampling: string;
  penetrationTestingPlan: string;
  scrForm: string;
  scrInventory: string;
  standardInventory: string;
  csoSecuritySelection: string;

  selectedProjectControlItems = [];

  locationCols: any[] = [
    {field: 'name', header: 'Date Center Site Name', width: '20%'},
    {field: 'address', header: 'Address', width: '50%'},
    {field: 'description', header: 'Description of Components', width: '30%'},
  ];
  locationFormGroup: FormGroup;
  locationDialogVisible = false;
  editedLocation: any;

  roleTestingExclusionCols: any[] = [
    {field: 'roleType', header: 'Role Type', width: '20%'},
    {field: 'exclusionReason', header: 'Reason of Exclusion', width: '50%'},
  ];
  roleTestingExclusionFormGroup: FormGroup;
  roleTestingExclusionDialogVisible = false;
  editedRoleTestingExclusion: any;

  securityAssessmentCols: any[] = [
    {field: 'name', header: 'Name', width: '20%'},
    {field: 'role', header: 'Assessment Role', width: '50%'},
    {field: 'validatedByIA', header: 'Validated by IA', width: '30%'},
    {field: 'validatedByCSP', header: 'Validated by CSP', width: '30%'},
  ];
  securityAssessmentFormGroup: FormGroup;
  securityAssessmentDialogVisible = false;
  editedSecurityAssessment: any;

  contactCols: any[] = [
    {field: 'name', header: 'Name', width: '50%'},
    {field: 'role', header: 'Role', width: '50%'},
  ];
  contactFormGroup: FormGroup;
  contactDialogVisible = false;
  editedContact: any;

  assessmentToolCols: any[] = [
    {field: 'name', header: 'Tool Name', width: '20%'},
    {field: 'vendor', header: 'Vendor/Organization Name & Version', width: '50%'},
    {field: 'purpose', header: 'Purpose of Tool', width: '30%'},
  ];
  assessmentToolFormGroup: FormGroup;
  assessmentToolDialogVisible = false;
  editedAssessmentTool: any;

  testCols: any[] = [
    {field: 'testId', header: 'Test ID', width: '20%'},
    {field: 'testName', header: 'Test Name', width: '50%'},
    {field: 'description', header: 'Description', width: '30%'},
  ];
  testFormGroup: FormGroup;
  testDialogVisible = false;
  editedTest: any;

  attackVectorCols: any[] = [
    {field: 'include', header: 'Include', width: '20%'},
    {field: 'name', header: 'Name', width: '50%'},
    {field: 'attackVectorKind', header: 'Type', width: '30%'},
  ];
  attackVectorFormGroup: FormGroup;
  attackVectorDialogVisible = false;
  editedAttackVector: any;

  roleTestingCols: any[] = [
    {field: 'roleName', header: 'Role Name', width: '20%'},
    {field: 'testUserId', header: 'Test User ID', width: '50%'},
    {field: 'associatedFunctions', header: 'Type', width: '30%'},
  ];
  roleTestingFormGroup: FormGroup;
  roleTestingDialogVisible = false;
  editedRoleTesting: any;

  attackVectorKinds = {
    0: 'Mandatory Attack Vector ',
    1: 'Internet based (Untrusted) ',
    2: 'CSP Corporate (Untrusted and Trusted) ',
    3: 'Internal Threat (Untrusted and Trusted) ',
    4: 'Enterprise ',
    5: 'Mobile ',
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public _formBuilder: FormBuilder,
    public projectService: ProjectService,
    public clientProfileService: ClientProfileService,
    public sapProfileService: SapProfileService,
    public fileBlobService: FileBlobService,
    public tenantService: TenantService,
    public alertService: AlertService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.api = window.location.origin || Constants.DefaultApiHost;
    this.token = LoginHelper.getFileToken();
    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe(s => this.pageTitle = s.menuLabels['SAP'] || 'SAP Profile');
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.clientProfileService.getClientProfiles(tenantName).subscribe(s => {
      this.itProfiles = s;
    });

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.formGroup = this._formBuilder.group({
      sapProfileId: [0],
      name: ['', Validators.required],
      cspName: [''],
      csoName: [''],
      version: [''],
      date: [new Date()],
      preparedByName: [''],
      preparedByAddress: [''],
      preparedByBuilding: [''],
      preparedByCity: [''],
      preparedForName: [''],
      preparedForAddress: [''],
      preparedForBuilding: [''],
      preparedForCity: [''],
      assessmentType: [0],
      iaName: [''],
      baselineInitial: [0],
      baselineAnnual: [0],
      isAlsoIncludesSignificant: [false],
      isSeveralSignificant: [false],
      aoJab: [0],
      relatedActivities: [0],
      includingThoseApplicable: [false],
      validatedControls: [''],
      alternativeControlImplementation: [''],
      willUseSampling: [false],
      willUseSamplingControls: [false],
      samplingControls: [''],
      captchaDescription: [''],
      oscpDescription: [''],
      testingNotified: [''],
      withinTestingDays: [0],
      iaRepresentativePrint: [''],
      iaRepresentativeSignature: [''],
      iaRepresentativeDate: [new Date()],
      cspRepresentativePrint: [''],
      cspRepresentativeSignature: [''],
      cspRepresentativeDate: [new Date()],
      projectId: [null],
      clientItProfileId: [null],
    });

    this.scopeFormGroup = this._formBuilder.group({
      packageId: ['', Validators.required],
      csoName: ['', Validators.required],
      cspName: ['', Validators.required],
      kind: [0]
    });

    this.locationFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      description: ['', Validators.required],
    });

    this.roleTestingExclusionFormGroup = this._formBuilder.group({
      roleType: ['', Validators.required],
      exclusionReason: ['', Validators.required],
    });

    this.securityAssessmentFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      role: ['', Validators.required],
      validatedByIA: [''],
      validatedByCSP: [''],
    });

    this.contactFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      role: ['', Validators.required],
    });

    this.assessmentToolFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      vendor: ['', Validators.required],
      purpose: ['', Validators.required],
    });

    this.testFormGroup = this._formBuilder.group({
      testId: ['', Validators.required],
      testName: ['', Validators.required],
      description: [''],
    });

    this.attackVectorFormGroup = this._formBuilder.group({
      include: [false],
      name: ['', Validators.required],
      attackVectorKind: [0],
    });

    this.roleTestingFormGroup = this._formBuilder.group({
      roleName: ['', Validators.required],
      testUserId: ['', Validators.required],
      associatedFunctions: ['', Validators.required],
    });

    this.route.params.subscribe(p => {
      this.sapProfileId = +p['id'];
      this.loadProfiles();
    });
  }

  loadProfiles() {
    this.sapProfileService.getSapProfiles()
      .subscribe((profiles: any[]) => {

        if (profiles == null) {
          return;
        }

        this.profiles = profiles;
        this.profile = profiles.find(p => p.sapProfileId == this.sapProfileId);
        if (!this.profile && this.profiles.length) {
          this.router.navigate(['/profiles', 'sapProfile', this.profiles[0].sapProfileId]);
        } else {
          this.assessmentScopes = this.profile.sapScopes.filter(s => s.kind === 0);
          this.leveragedScopes = this.profile.sapScopes.filter(s => s.kind === 1);
          this.selectProfile(this.profile);
        }
      });
  }

  onProfileChanged(event) {
    this.router.navigate(['/profiles/sapProfile', event.value]);
  }

  createProfile() {
    this.sapProfileService
      .saveSapProfile({name: 'IT Profile'})
      .subscribe((r) => this.router.navigate(['/profiles/sapProfile', r.sapProfileId]));
  }

  selectProfile(profile) {
    this.projectService.getAllShort().subscribe(p => {
      this.projects = p;
      this.selectProject(profile.projectId || p[0].projectId);

    });

    if (!profile) {
      profile = {
        sapProfileId: 0,
        name: '',
        cspName: '',
        csoName: '',
        version: '',
        date: new Date(),
        preparedByName: '',
        preparedByAddress: '',
        preparedByBuilding: '',
        preparedByCity: '',
        preparedForName: '',
        preparedForAddress: '',
        preparedForBuilding: '',
        preparedForCity: '',
        assessmentType: 0,
        iaName: '',
        baselineInitial: 0,
        baselineAnnual: 0,
        isAlsoIncludesSignificant: false,
        isSeveralSignificant: false,
        aoJab: 0,
        relatedActivities: 0,
        includingThoseApplicable: false,
        validatedControls: '',
        alternativeControlImplementation: '',
        willUseSampling: false,
        willUseSamplingControls: false,
        samplingControls: '',
        captchaDescription: '',
        oscpDescription: '',
        testingNotified: '',
        withinTestingDays: 0,
        iaRepresentativePrint: '',
        iaRepresentativeSignature: '',
        iaRepresentativeDate: new Date(),
        cspRepresentativePrint: '',
        cspRepresentativeSignature: '',
        cspRepresentativeDate: new Date(),
        projectId: null,
        clientItProfileId: null,
        securityControlSampling: '',
        penetrationTestingPlan: '',
        scrForm: '',
        scrInventory: '',
        standardInventory: '',
        csoSecuritySelection: '',
      };
    }

    this.profile = profile;
    this.formGroup.patchValue({
      sapProfileId: this.profile.sapProfileId,
      name: this.profile.name,
      cspName: this.profile.cspName,
      csoName: this.profile.csoName,
      version: this.profile.version,
      date: this.profile.date,
      preparedByName: this.profile.preparedByName,
      preparedByAddress: this.profile.preparedByAddress,
      preparedByBuilding: this.profile.preparedByBuilding,
      preparedByCity: this.profile.preparedByCity,
      preparedForName: this.profile.preparedForName,
      preparedForAddress: this.profile.preparedForAddress,
      preparedForBuilding: this.profile.preparedForBuilding,
      preparedForCity: this.profile.preparedForCity,
      assessmentType: this.profile.assessmentType,
      iaName: this.profile.iaName,
      baselineInitial: this.profile.baselineInitial,
      baselineAnnual: this.profile.baselineAnnual,
      isAlsoIncludesSignificant: this.profile.isAlsoIncludesSignificant,
      isSeveralSignificant: this.profile.isSeveralSignificant,
      aoJab: this.profile.aoJab,
      relatedActivities: this.profile.relatedActivities,
      includingThoseApplicable: this.profile.includingThoseApplicable,
      validatedControls: this.profile.validatedControls,
      alternativeControlImplementation: this.profile.alternativeControlImplementation,
      willUseSampling: this.profile.willUseSampling,
      willUseSamplingControls: this.profile.willUseSamplingControls,
      samplingControls: this.profile.samplingControls,
      captchaDescription: this.profile.captchaDescription,
      oscpDescription: this.profile.oscpDescription,
      testingNotified: this.profile.testingNotified,
      withinTestingDays: this.profile.withinTestingDays,
      iaRepresentativePrint: this.profile.iaRepresentativePrint,
      iaRepresentativeSignature: this.profile.iaRepresentativeSignature,
      iaRepresentativeDate: this.profile.iaRepresentativeDate,
      cspRepresentativePrint: this.profile.cspRepresentativePrint,
      cspRepresentativeSignature: this.profile.cspRepresentativeSignature,
      cspRepresentativeDate: this.profile.cspRepresentativeDate,
      projectId: this.profile.projectId,
      clientItProfileId: this.profile.clientItProfileId,
    });
    this.csoSecuritySelection = this.profile.csoSecuritySelection;
    this.scrForm = this.profile.scrForm;
    this.securityControlSampling = this.profile.securityControlSampling;
    this.penetrationTestingPlan = this.profile.penetrationTestingPlan;
    this.scrInventory = this.profile.scrInventory;
    this.standardInventory = this.profile.standardInventory;
  }

  selectProject(projectId) {
    this.projectService.getById(projectId).subscribe(
      p => {
        this.projectControlItems = p.projectControlItems;
        this.projectControlItems.forEach(s => s.checked = (this.profile.projectControlItemIds || []).indexOf(s.projectControlItemId) >= 0);
        console.log(p.projectControlItems)
        this.updateRowGroupMetaData(p.projectControlItems);
        this.projectItProfiles = this.projects.find(p => p.projectId == projectId).clientITProfileIds.split(';').map(i => this.itProfiles.find(p => p.clientITProfileId == i)).filter(p => p);
      });

  }

  projectChanged(e) {
    this.selectProject(e.value);
  }

  onDone() {
    if (!this.formGroup.valid) return;
    this.alertService.clear();
    this.sapProfileService.saveSapProfile({
      ...this.profile, ...this.formGroup.value,
      csoSecuritySelection: this.csoSecuritySelection,
      securityControlSampling: this.securityControlSampling,
      penetrationTestingPlan: this.penetrationTestingPlan,
      scrForm: this.scrForm,
      scrInventory: this.scrInventory,
      standardInventory: this.standardInventory,
      sapScopes: [...this.assessmentScopes || [], ...this.leveragedScopes || []],
      projectControlItems: (this.projectControlItems || []).filter(p => p.checked)
    })
      .subscribe(() => {
          this.alertService.success("Profile Successfully Saved");
          this.loadProfiles();
        },
        error => {
          const errorMessage = 'An error occurred while updating client SAP profile.';
          this.alertService.error(errorMessage);
        }
      );
  }

  removeProfile() {
    this.sapProfileService.deleteSapProfile(this.profile.sapProfileId).subscribe(() => {
      this.router.navigate(['/profiles/sapProfile']);
    });
  }

  showScopeDialog(item) {
    this.editedScope = item;
    this.scopeFormGroup.setValue({
      packageId: item.packageId,
      csoName: item.csoName,
      cspName: item.cspName,
      kind: item.kind
    });
    this.scopeDialogVisible = true;
  }

  saveScope() {
    if (!this.scopeFormGroup.valid) {
      Object.keys(this.scopeFormGroup.controls).forEach(field => {
        const control = this.scopeFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.scopeFormGroup.value;
    if (this.editedScope.kind === 0) {
      const pos = this.assessmentScopes.indexOf(this.editedScope);
      if (pos >= 0) {
        this.assessmentScopes[pos] = {...this.editedScope, ...data};
        this.assessmentScopes = [...this.assessmentScopes];
      } else {
        this.assessmentScopes = [...this.assessmentScopes, data];
      }
    } else {
      const pos = this.leveragedScopes.indexOf(this.editedScope);
      if (pos >= 0) {
        this.leveragedScopes[pos] = {...this.editedScope, ...data};
        this.leveragedScopes = [...this.leveragedScopes];
      } else {
        this.leveragedScopes = [...this.leveragedScopes, data];
      }
    }
    this.scopeDialogVisible = false;
    this.editedScope = null;
  }

  deleteScope(item) {
    if (item.kind === 0) {
      this.assessmentScopes = this.assessmentScopes.filter(q => q !== item);
    } else {
      this.leveragedScopes = this.leveragedScopes.filter(q => q !== item);
    }
  }

  showLocationDialog(item = <any>{}) {
    this.editedLocation = item;
    this.locationFormGroup.setValue({
      name: item.name || '',
      address: item.address || '',
      description: item.description || ''
    });
    this.locationDialogVisible = true;
  }

  saveLocation() {
    if (!this.locationFormGroup.valid) {
      Object.keys(this.locationFormGroup.controls).forEach(field => {
        const control = this.locationFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.locationFormGroup.value;
    const pos = this.profile.sapLocations.indexOf(this.editedLocation);
    if (pos >= 0) {
      this.profile.sapLocations[pos] = {...this.editedLocation, ...data};
      this.profile.sapLocations = [...this.profile.sapLocations];
    } else {
      this.profile.sapLocations = [...this.profile.sapLocations, {...data}];
    }
    this.locationDialogVisible = false;
    this.editedLocation = null;
  }

  deleteLocation(item) {
    this.profile.sapLocations = this.profile.sapLocations.filter(s => s !== item);
  }

  showRoleTestingExclusionDialog(item = <any>{}) {
    this.editedRoleTestingExclusion = item;
    this.roleTestingExclusionFormGroup.setValue({
      roleType: item.roleType || '',
      exclusionReason: item.exclusionReason || ''
    });
    this.roleTestingExclusionDialogVisible = true;
  }

  saveRoleTestingExclusion() {
    if (!this.roleTestingExclusionFormGroup.valid) {
      Object.keys(this.roleTestingExclusionFormGroup.controls).forEach(field => {
        const control = this.roleTestingExclusionFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.roleTestingExclusionFormGroup.value;
    const pos = this.profile.sapRoleTestingExclusions.indexOf(this.editedRoleTestingExclusion);
    if (pos >= 0) {
      this.profile.sapRoleTestingExclusions[pos] = {...this.editedRoleTestingExclusion, ...data};
      this.profile.sapRoleTestingExclusions = [...this.profile.sapRoleTestingExclusions];
    } else {
      this.profile.sapRoleTestingExclusions = [...this.profile.sapRoleTestingExclusions, {...data}];
    }
    this.roleTestingExclusionDialogVisible = false;
    this.editedRoleTestingExclusion = null;
  }

  deleteRoleTestingExclusion(item) {
    this.profile.sapRoleTestingExclusions = this.profile.sapRoleTestingExclusions.filter(s => s !== item);
  }

  showSecurityAssessmentDialog(item = <any>{}) {
    this.editedSecurityAssessment = item;
    this.securityAssessmentFormGroup.setValue({
      name: item.name || '',
      role: item.role || '',
      validatedByIA: item.validatedByIA || '',
      validatedByCSP: item.validatedByCSP || '',
    });
    this.securityAssessmentDialogVisible = true;
  }

  saveSecurityAssessment() {
    if (!this.securityAssessmentFormGroup.valid) {
      Object.keys(this.securityAssessmentFormGroup.controls).forEach(field => {
        const control = this.securityAssessmentFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.securityAssessmentFormGroup.value;
    const pos = this.profile.sapSecurityAssessments.indexOf(this.editedSecurityAssessment);
    if (pos >= 0) {
      this.profile.sapSecurityAssessments[pos] = {...this.editedSecurityAssessment, ...data};
      this.profile.sapSecurityAssessments = [...this.profile.sapSecurityAssessments];
    } else {
      this.profile.sapSecurityAssessments = [...this.profile.sapSecurityAssessments, {...data}];
    }
    this.securityAssessmentDialogVisible = false;
    this.editedSecurityAssessment = null;
  }

  deleteSecurityAssessment(item) {
    this.profile.sapSecurityAssessments = this.profile.sapSecurityAssessments.filter(s => s !== item);
  }

  showContactDialog(item = <any>{}) {
    this.editedContact = item;
    this.contactFormGroup.setValue({
      name: item.name || '',
      role: item.role || '',
    });
    this.contactDialogVisible = true;
  }

  saveContact() {
    if (!this.contactFormGroup.valid) {
      Object.keys(this.contactFormGroup.controls).forEach(field => {
        const control = this.contactFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.contactFormGroup.value;
    const pos = this.profile.sapContacts.indexOf(this.editedContact);
    if (pos >= 0) {
      this.profile.sapContacts[pos] = {...this.editedContact, ...data};
      this.profile.sapContacts = [...this.profile.sapContacts];
    } else {
      this.profile.sapContacts = [...this.profile.sapContacts, {...data}];
    }
    this.contactDialogVisible = false;
    this.editedContact = null;
  }

  deleteContact(item) {
    this.profile.sapContacts = this.profile.sapContacts.filter(s => s !== item);
  }

  showAssessmentToolDialog(item = <any>{}) {
    this.editedAssessmentTool = item;
    this.assessmentToolFormGroup.setValue({
      name: item.name || '',
      vendor: item.vendor || '',
      purpose: item.purpose || ''
    });
    this.assessmentToolDialogVisible = true;
  }

  saveAssessmentTool() {
    if (!this.assessmentToolFormGroup.valid) {
      Object.keys(this.assessmentToolFormGroup.controls).forEach(field => {
        const control = this.assessmentToolFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.assessmentToolFormGroup.value;
    const pos = this.profile.sapAssessmentTools.indexOf(this.editedAssessmentTool);
    if (pos >= 0) {
      this.profile.sapAssessmentTools[pos] = {...this.editedAssessmentTool, ...data};
      this.profile.sapAssessmentTools = [...this.profile.sapAssessmentTools];
    } else {
      this.profile.sapAssessmentTools = [...this.profile.sapAssessmentTools, {...data}];
    }
    this.assessmentToolDialogVisible = false;
    this.editedAssessmentTool = null;
  }

  deleteAssessmentTool(item) {
    this.profile.sapAssessmentTools = this.profile.sapAssessmentTools.filter(s => s !== item);
  }

  showTestDialog(item = <any>{}) {
    this.editedTest = item;
    this.testFormGroup.setValue({
      testId: item.testId || '',
      testName: item.testName || '',
      description: item.description || ''
    });
    this.testDialogVisible = true;
  }

  saveTest() {
    if (!this.testFormGroup.valid) {
      Object.keys(this.testFormGroup.controls).forEach(field => {
        const control = this.testFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.testFormGroup.value;
    const pos = this.profile.sapTests.indexOf(this.editedTest);
    if (pos >= 0) {
      this.profile.sapTests[pos] = {...this.editedTest, ...data};
      this.profile.sapTests = [...this.profile.sapTests];
    } else {
      this.profile.sapTests = [...this.profile.sapTests, {...data}];
    }
    this.testDialogVisible = false;
    this.editedTest = null;
  }

  deleteTest(item) {
    this.profile.sapTests = this.profile.sapTests.filter(s => s !== item);
  }

  showAttackVectorDialog(item = <any>{}) {
    this.editedAttackVector = item;
    this.attackVectorFormGroup.setValue({
      include: item.include || false,
      name: item.name || '',
      attackVectorKind: item.attackVectorKind || 0
    });
    this.attackVectorDialogVisible = true;
  }

  saveAttackVector() {
    if (!this.attackVectorFormGroup.valid) {
      Object.keys(this.attackVectorFormGroup.controls).forEach(field => {
        const control = this.attackVectorFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.attackVectorFormGroup.value;
    const pos = this.profile.sapAttackVectors.indexOf(this.editedAttackVector);
    if (pos >= 0) {
      this.profile.sapAttackVectors[pos] = {...this.editedAttackVector, ...data};
      this.profile.sapAttackVectors = [...this.profile.sapAttackVectors];
    } else {
      this.profile.sapAttackVectors = [...this.profile.sapAttackVectors, {...data}];
    }
    this.attackVectorDialogVisible = false;
    this.editedAttackVector = null;
  }

  deleteAttackVector(item) {
    this.profile.sapAttackVectors = this.profile.sapAttackVectors.filter(s => s !== item);
  }

  showRoleTestingDialog(item = <any>{}) {
    this.editedRoleTesting = item;
    this.roleTestingFormGroup.setValue({
      roleName: item.roleName || '',
      testUserId: item.testUserId || '',
      associatedFunctions: item.associatedFunctions || ''
    });
    this.roleTestingDialogVisible = true;
  }

  saveRoleTesting() {
    if (!this.roleTestingFormGroup.valid) {
      Object.keys(this.roleTestingFormGroup.controls).forEach(field => {
        const control = this.roleTestingFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = this.roleTestingFormGroup.value;
    const pos = this.profile.sapRoleTestings.indexOf(this.editedRoleTesting);
    if (pos >= 0) {
      this.profile.sapRoleTestings[pos] = {...this.editedRoleTesting, ...data};
      this.profile.sapRoleTestings = [...this.profile.sapRoleTestings];
    } else {
      this.profile.sapRoleTestings = [...this.profile.sapRoleTestings, {...data}];
    }
    this.roleTestingDialogVisible = false;
    this.editedRoleTesting = null;
  }

  deleteRoleTesting(item) {
    this.profile.sapRoleTestings = this.profile.sapRoleTestings.filter(s => s !== item);
  }

  updateRowGroupMetaData(data) {
    this.rowGroupMetadata = {};
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  public addSapProfileAttachments(event, number) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      this.sapProfileService.uploadAttachment(attachments[0])
        .subscribe(data => {
          switch (number) {
            case 1:
              this.csoSecuritySelection = attachments[0].name;
              break;
            case 2:
              this.securityControlSampling = attachments[0].name;
              break;
            case 3:
              this.penetrationTestingPlan = attachments[0].name;
              break;
            case 4:
              this.scrForm = attachments[0].name;
              break;
            case 5:
              this.scrInventory = attachments[0].name;
              break;
            case 6:
              this.standardInventory = attachments[0].name;
              break;
          }
        });
    }
  }

  public downloadFile(fileName: string) {

    this.fileBlobService.downloadFile(fileName, "Account/SAP Profile")
      .subscribe(blob => {
          importedSaveAs(new Blob([blob]), fileName);
        },
        error => {
          const errorMessage = 'An error occurred while downloading file.';
          this.alertService.error(errorMessage);
        });
  }


  public downloadAttachmentFile(number) {

    switch (number) {
      case 1:
        this.downloadFile(this.csoSecuritySelection);
        break;
      case 2:
        this.downloadFile(this.securityControlSampling);
        break;
      case 3:
        this.downloadFile(this.penetrationTestingPlan);
        break;
      case 4:
        this.downloadFile(this.scrForm);
        break;
      case 5:
        this.downloadFile(this.scrInventory);
        break;
      case 6:
        this.downloadFile(this.standardInventory);
        break;


    }
  }


}
